module.exports = __webpack_public_path__ + "static/img/剑.9356b82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuqi/剑.png
// module id = 958G
// module chunks = 3